/* global axios */
// Keep Chatwoot's configured authentication client. No tokens in module caches.
const base = '/whatsapp-manager/api';
const id = (value) => encodeURIComponent(String(value));
const get = async (path, options = {}) =>
  (await axios.get(base + path, options)).data;
const post = async (path, body) => (await axios.post(base + path, body)).data;
export const isWahaInbox = (inbox) =>
  inbox?.channel_type === 'Channel::Api' &&
  inbox?.borderchat_provider === 'waha';
export default {
  state: (options) => get('/state', options),
  proxies: (options) => get('/proxies', options),
  chatwoot: () => get('/chatwoot'),
  qr: (value) => get(`/sessions/${id(value)}/qr`, { responseType: 'blob' }),
  prepareQr: (value, recover = true) =>
    post(`/sessions/${id(value)}/qr/prepare`, { recover }),
  requestPairingCode: (value, phoneNumber) =>
    post(`/sessions/${id(value)}/pairing-code`, { phoneNumber }),
  pairingStatus: (value) => get(`/sessions/${id(value)}/pairing-status`),
  saveProxy: async (value, body) =>
    (value
      ? await axios.patch(`${base}/proxies/${id(value)}`, body)
      : await axios.post(`${base}/proxies`, body)
    ).data,
  deleteProxy: async (value) =>
    (await axios.delete(`${base}/proxies/${id(value)}`, { data: {} })).data,
  testProxy: (value) => post(`/proxies/${id(value)}/test`, {}),
  createSession: (body) => post('/sessions', body),
  changeProxy: (value, proxyId) =>
    post(`/sessions/${id(value)}/proxy`, { proxy_id: proxyId }),
  action: (value, action) => {
    if (!['start', 'restart', 'stop', 'logout'].includes(action))
      throw new Error('不支持的账号操作');
    return post(`/sessions/${id(value)}/${action}`, { confirm: action });
  },
  createInbox: (value, name) =>
    post(`/sessions/${id(value)}/inbox/create`, { name }),
  bindInbox: (value, inboxId) =>
    post(`/sessions/${id(value)}/inbox`, { inbox_id: Number(inboxId) }),
  deleteAccount: (value, session, inboxId) =>
    post(`/sessions/${id(value)}/delete-account`, {
      confirm: 'delete_account_and_login_data',
      session,
      inbox_id: inboxId ?? null,
    }),
  retryDeletion: (value, session) =>
    post(`/sessions/${id(value)}/delete-account/retry`, {
      confirm: 'retry_account_deletion',
      session,
    }),
  cleanup: (value) =>
    post(`/inboxes/${id(value)}/cleanup`, { confirm: 'delete_inbox' }),
  retryCleanup: (value) =>
    post(`/inboxes/${id(value)}/cleanup/retry`, { confirm: 'retry_cleanup' }),
};
